/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  ActionItem,
  ActionItemSnoozeRequestRequest,
  PaginatedActionItemList,
  WorkQueueListParams
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type workQueueListResponse200 = {
  data: PaginatedActionItemList
  status: 200
}

export type workQueueListResponseSuccess = (workQueueListResponse200) & {
  headers: Headers;
};
;

export type workQueueListResponse = (workQueueListResponseSuccess)

export const getWorkQueueListUrl = (params?: WorkQueueListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["event_type","portfolio","region","severity","suggested_action"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/work-queue/?${stringifiedParams}` : `/api/v1/work-queue/`
}

export const workQueueList = async (params?: WorkQueueListParams, options?: RequestInit): Promise<workQueueListResponse> => {

  return customFetch<workQueueListResponse>(getWorkQueueListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type workQueueSnoozeCreateResponse200 = {
  data: ActionItem
  status: 200
}

export type workQueueSnoozeCreateResponseSuccess = (workQueueSnoozeCreateResponse200) & {
  headers: Headers;
};
;

export type workQueueSnoozeCreateResponse = (workQueueSnoozeCreateResponseSuccess)

export const getWorkQueueSnoozeCreateUrl = (id: string,) => {




  return `/api/v1/work-queue/${id}/snooze/`
}

/**
 * Temporarily dismiss an item for ``days`` days (shared across users).
 */
export const workQueueSnoozeCreate = async (id: string,
    actionItemSnoozeRequestRequest: ActionItemSnoozeRequestRequest, options?: RequestInit): Promise<workQueueSnoozeCreateResponse> => {

  return customFetch<workQueueSnoozeCreateResponse>(getWorkQueueSnoozeCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(actionItemSnoozeRequestRequest)
  }
);}


export type workQueueUnsnoozeCreateResponse200 = {
  data: ActionItem
  status: 200
}

export type workQueueUnsnoozeCreateResponseSuccess = (workQueueUnsnoozeCreateResponse200) & {
  headers: Headers;
};
;

export type workQueueUnsnoozeCreateResponse = (workQueueUnsnoozeCreateResponseSuccess)

export const getWorkQueueUnsnoozeCreateUrl = (id: string,) => {




  return `/api/v1/work-queue/${id}/unsnooze/`
}

export const workQueueUnsnoozeCreate = async (id: string, options?: RequestInit): Promise<workQueueUnsnoozeCreateResponse> => {

  return customFetch<workQueueUnsnoozeCreateResponse>(getWorkQueueUnsnoozeCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}


